import { render, staticRenderFns } from "./ActivityUpdateModal.vue?vue&type=template&id=12a3172c&scoped=true"
import script from "./ActivityUpdateModal.vue?vue&type=script&lang=ts"
export * from "./ActivityUpdateModal.vue?vue&type=script&lang=ts"
import style0 from "./ActivityUpdateModal.vue?vue&type=style&index=0&id=12a3172c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3172c",
  null
  
)

export default component.exports